import _ from 'lodash';
const ONE = 1;
const TWO = 2;
const FIVE = 5;
const SIX = 6;
const EIGHT = 8;
const NINE = 9;
const TEN = 10;
const FIFTEEN = 15;
const EIGHTEEN = 18;
const NINETEEN = 19;
const TWENTYEIGHT = 28;
const FOURTY = 40;
const SIXTY = 60;
export const required = value => (value ? undefined : 'Required');
export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
export const maxLength5 = maxLength(FIVE);
export const maxLength8 = maxLength(EIGHT);
export const taxIdMax = maxLength(NINE);
export const maxLength10 = maxLength(TEN);
export const maxLength15 = maxLength(FIFTEEN);
export const number = value =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined;
export const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;
export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters` : undefined;
export const maxLength2 = max => value =>
  value && value.length > max ? `State is Required` : undefined;
export const minValue18 = minValue(EIGHTEEN);
export const PassRequired = value =>
  value ? undefined : 'Please specify the correct Password.';
export const maxLengthTen = max => value =>
  value && value.length >= max ? `Must be ${max} characters` : undefined;

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Please enter a valid Email address format.'
    : undefined;
export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined;
export const password = value => {
  // let strongRegex = !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{7,15})$/i

  return value && !/^((?=.*\d)(?=.*[A-Z])(?=.*\W).{7,25})$/i.test(value)
    ? 'Invalid password combination.'
    : undefined;
};

export const zipCode = minLength(FIVE);
export const taxIdMin = minLength(NINE);
export const accountMax = minLength(TEN);
export const firstName = maxLength(TWENTYEIGHT);
export const lastName = maxLength(TWENTYEIGHT);
export const companyName = maxLength(SIXTY);
export const street = maxLength(FOURTY);
export const streetline2 = maxLength(FOURTY);
export const city = maxLength(NINETEEN);
export const emailAddress = email;
export const state = maxLength2(TWO);
export const code = maxLength(SIX);
export const phoneNumberMin = phoneNumber;
export const bondNo = maxLength(FIFTEEN);

export const isURL = value => {
  if (_.isEmpty(value)) {
    return undefined;
  }
  /*  else {
    return value &&
      !/^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/i.test(value)
      ? undefined
      : 'Please provide the valid website format'
  }  */
};

/* function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
} */

export const passwordsMustMatch = (value, allValues) =>
  value !== allValues.newPassword ? 'Passwords do not match' : undefined;

export const numberFormat = value => {
  if (value === undefined) return;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value.toString().replace(/,/g, ''));
};

export const formatAmount = input => {
  if (!input) return;
  return input
    .toString()
    .replace(/,/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatPhoneNumber = phoneNumberString => {
  if (phoneNumberString !== undefined) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
  }
  return null;
};

export const normalize = value => {
  return value.replace(/,/g, '');
};

export const maskAccount = (number, maskLength) => {
  let result =
    Array(Math.max(10 - String(number).length + 1, 0)).join(0) + number;
  return 'xxxxx' + result.substring(result.length - maskLength);
};

export const toTitleCase = str => {
  if (str !== undefined) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
};

export const getAddress = (street, street2) => {
  let address;
  if (street2 !== undefined && street2 !== null && street2 !== '') {
    address = toTitleCase(street) + toTitleCase(street2);
  } else {
    address = toTitleCase(street);
  }
  return address;
};

export const toWords = (toWords, value) => {
  let result = toWords.convert(value, { currency: true });
  return toTitleCase(result.slice(0, -4));
};

export const underlineData = value => {
  console.log(value);
  let x, newValue;
  if (value === undefined) {
    return null;
  } else {
    x = String(Math.floor(Math.abs(value))).length;
    newValue = value + new Array(60 - x).join(' ');
  }
  return newValue.toString();
};
export const getDueDate = (depositDueDate, moment) => {
  return depositDueDate !== '' &&
    depositDueDate !== undefined &&
    depositDueDate !== null
    ? moment(depositDueDate).format('MM-DD-YYYY')
    : 'Pending';
};
export const underlineData1 = (value, spaces) => {
  let x, newValue;
  if (value === undefined) {
    return null;
  } else {
    x = String(Math.floor(Math.abs(value))).length;
    newValue = value + new Array(spaces - x).join(' ');
  }
  return newValue.toString();
};

export const bondAmount = value =>
  value && isNaN(Number(value.replace(/,/g, '')))
    ? 'Must be a number'
    : undefined;
export const bondAmountValue = minValue(ONE);


export const DEPOSIT_ADMIN_EMAIL_TEMPLATE_NAME = 'DepositAdminEmail';
export const DEPOSIT_ADMIN_EMAIL_STATUS_TEMPLATE_NAME =
  'DepositAdminEmail-status';

export const DEPADMIN_EMAIL_UPDATE_SUBJECT =
  'A Surety Bond Application is Ready for Review';

export const EMAIL_REGISTER_SUBJECT =
  'SuccessFully registered to Non Cash Deposit Portal';
export const depAdminSubject = (district, status) =>
  `District : ` + district + `  Status: ` + status + ` is Ready for Review`;

export const PASSWORD_POLICY = `Password must  be 8-25 characters long and contain at least one uppercase letter,
   one lowercase letter, one number and one special character such as (@$!%*#?&).
    Password is case sensitive.`;
export const DepsoitAdminEmail =
  'Deposit-Administration.SharedMailbox@nexteraenergy.com';
